import axios from 'axios'

export const baseURL =
  process.env.VUE_APP_API_ENTRYPOINT || 'https://localhost:9443'

export default axios.create({
  baseURL: baseURL,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
})
